import {Component, OnInit} from '@angular/core';
import {FieldComponentAbstract} from '../abstracts/FieldComponentAbstract';
import {SelectFieldService} from '../../services/select-field/select-field.service';
import {CurrentUserService} from '../../../user/services/current-user/current-user.service';
import {MdSelectChange} from '@angular/material';
import {FieldOption} from '../../../form-renderer/interfaces/FieldOption';
import {ERoles} from '../../../user/enums/e-roles.enum';

@Component({
  selector: 'app-select',
  templateUrl: './select-field.component.html',
  styleUrls: ['./select-field.component.css']
})
export class SelectFieldComponent extends FieldComponentAbstract  implements OnInit {
  isSupervisor = false;

  constructor(private selectService: SelectFieldService,
              private currentUserService: CurrentUserService) {
    super();
  }

  async ngOnInit() {
    this.fieldValue.field.options = await this.selectService.getOptions(this.fieldValue);
    this.isSupervisor = (await this.currentUserService.getCurrentUser().toPromise()).hasRole(ERoles.SUPERVISOR)
  }

  handleChange(ev: MdSelectChange) {
    this.fieldValue.select_value = ev.value;
    this.onChange(this.fieldValue);
  }

  getDisabled(option: FieldOption) {
    if (this.isSupervisor && this.hasRole(option, ERoles.SUPERVISOR))
      return false;
    return this.isSupervisor;
  }

  public hasRole(object: any, role: string) {
    for (const rol of object.roles)
      if (rol.name === role)
        return true;
    return false;
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/select-field/select-field.component.ts